import React, { useEffect, useRef, useState } from "react";
import { storyblokEditable } from "@storyblok/react";

import { SliderPanelModel } from "./SliderPanelModel";
import SliderPanelItem from "./SliderPanelItem/SliderPanelItem";
import { SolutionsModel } from "../ListPanel/ListPanelModel";
import SolutionsSliderPanelItem from "./SolutionsSliderPanelItem/SolutionsSliderPanelItem";
import SliderPanelUtils from "./SliderPanelUtils";

import "./SliderPanel.css";

const SliderPanel: React.FC<{ blok: SliderPanelModel }> = ({ blok }) => {
  const sliderPanelRef = useRef<HTMLDivElement>(null);
  const [selectedItem, setSelectedItem] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [displayAnnuallyOrMonthlySwitch, setDisplayAnnuallyOrMonthlySwitch] =
    useState(false);

  const handleToggle = () => {
    setIsChecked(!isChecked);
  };

  useEffect(() => {
    setSelectedItem(SliderPanelUtils.getSelectedItem(blok));
    if (
      blok?.items?.some((x) =>
        x.entity?.some((e) => e.content?.productType === "Subscription")
      )
    ) {
      setDisplayAnnuallyOrMonthlySwitch(true);
    }
  }, [blok]);

  if (!blok?.items || blok.items.length < 1) {
    return null;
  }

  let cssclass = "";
  if (blok.items.length === 1) {
    cssclass = "one-item";
  } else if (blok.items.length === 2) {
    cssclass = "two-items";
  }

  const handleItemClick = (selectedItem: string) => {
    setSelectedItem(selectedItem);
  };

  return (
    <div
      {...storyblokEditable(blok)}
      className="slider-panel"
      style={{ backgroundColor: blok.backgroundColor }}
      ref={sliderPanelRef}
    >
      <div className="slider-panel-container" style={{ color: blok.textColor }}>
        {blok.title && (
          <div className="title">
            <span>{blok.title}</span>
          </div>
        )}
        <div className="standfirst">
          <span>{blok.standfirst}</span>
        </div>
        {displayAnnuallyOrMonthlySwitch && (
          <div className="switch-container">
            <span className="slider-label">Annually</span>
            <label className="switch">
              <input
                type="checkbox"
                checked={isChecked}
                onChange={handleToggle}
              />
              <span className="slider"></span>
            </label>
            <span className="slider-label">Monthly</span>
          </div>
        )}
        <div className={`slider-panel-content ${cssclass}`}>
          {blok
            ? blok.items.map((item) => {
                if (!item?.entity || item.entity.length < 1) {
                  return null;
                }
                if (
                  item.entity[0].content &&
                  (item.entity[0].content as SolutionsModel)?.component ===
                    "SolutionsEntity"
                ) {
                  return (
                    <SolutionsSliderPanelItem
                      blok={item}
                      selectedItem={selectedItem}
                      onClick={() =>
                        handleItemClick(
                          item?.entity[0]?.content
                            ? (item?.entity[0]?.content as SolutionsModel).name
                            : ""
                        )
                      }
                      key={`item-${item._uid}`}
                    ></SolutionsSliderPanelItem>
                  );
                }
                return (
                  <SliderPanelItem
                    blok={item}
                    selectedItem={selectedItem}
                    displayAnnuallyOrMonthlySwitch={
                      displayAnnuallyOrMonthlySwitch
                    }
                    isChecked={isChecked}
                    onClick={() =>
                      handleItemClick(
                        item?.entity[0]?.content?.productName + item?.tier
                      )
                    }
                    key={`item-${item._uid}`}
                  ></SliderPanelItem>
                );
              })
            : null}
        </div>
      </div>
    </div>
  );
};

export default SliderPanel;
